import React, { useEffect } from 'react';

// This component will dynamically add the Google Font to the document's head
const FontLoader = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Optional: clean up the link tag when the component unmounts
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return null;
};

// Google's official G logo for the button
const GoogleIcon = () => (
    <svg className="w-5 h-5 mr-3" viewBox="0 0 48 48">
        <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path>
        <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path>
        <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path>
        <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
    </svg>
);

export default function LoginPage({ onSignIn }) {
  return (
    <>
      <FontLoader />
      <style>{`
        .font-roboto { font-family: 'Roboto', sans-serif; }
      `}</style>
      <div className="flex items-center justify-center min-h-screen bg-gray-100 font-roboto text-[#213368]">
        <div className="relative flex flex-col m-6 space-y-8 bg-white shadow-2xl rounded-2xl md:flex-row md:space-y-0">
          {/* Left Side */}
          <div className="relative h-64 md:h-auto md:flex-1">
            <img
              src="/image.png"
              alt="A graphic collage of icons representing various admin tasks like finance, HR, and management"
              className="object-cover w-full h-full rounded-t-2xl md:rounded-l-2xl md:rounded-t-none"
            />
            {/* Text on image */}
            <div className="absolute bottom-10 left-10 p-4 bg-[#00a89d] bg-opacity-80 rounded-lg">
              <h1 className="text-3xl font-medium text-white">Admin Platform</h1>
              <p className="mt-2 text-white">Secure, streamlined, and efficient management.</p>
            </div>
          </div>

          {/* Right Side */}
          <div className="flex flex-col justify-center p-8 md:p-14 flex-1">
            <div className="mb-8 text-center">
               <img src="/Brand_logo.png" alt="LINC Education Logo" className="w-48 h-auto mx-auto mb-4"/>
               <h1 className="mt-4 text-3xl font-medium text-[#213368]">Sign In to Your Account</h1>
               <p className="text-gray-500">Welcome back! Please sign in using your Google account.</p>
            </div>

            <div className="mt-6">
              <button
                onClick={onSignIn}
                className="w-full flex justify-center items-center py-3 px-4 font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#213368] transition-all duration-300"
              >
                <GoogleIcon />
                <span>Sign in with Google</span>
              </button>
            </div>

            <div className="mt-8 text-xs text-center text-gray-400">
               &copy; {new Date().getFullYear()} LINC Education Services Pte. Ltd. All rights reserved.
               <br />
               <a href="https://linceducation.com/privacy_policy.html" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-600">
                 Privacy Policy
               </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

